"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("../../hooks");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const molecules_1 = require("../../molecules");
const TabCarousel_1 = __importDefault(require("../TabCarousel"));
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const ar_mode_1 = require("@completeanatomy/ar-mode");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const selectors_1 = require("../../selectors");
const selectSpecificDetails = (0, selectors_1.createPropertiesSelector)(selectors_1.selectDetails, 'names', 'isAudioPlaying', 'audio');
function InfoBoxMobile() {
    const { identifier } = (0, models_1.useSelectedPart)();
    const infoBoxDetails = (0, hooks_1.useSelector)(selectSpecificDetails);
    const [{ isExpanded }] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const isARModeActive = (0, ar_mode_1.useIsARModeActive)();
    const { names, audio, isAudioPlaying } = infoBoxDetails || {};
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !!identifier && !isARModeActive, timeout: 200, mountOnEnter: true, unmountOnExit: true, classNames: "infoBox", "data-e2e": 'InfoBoxMobile_CSSTransition', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { timeout: 200, in: isExpanded, classNames: "content", "data-e2e": 'InfoBoxMobile_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'InfoBoxMobile_Container', children: [(0, jsx_runtime_1.jsx)(molecules_1.ControlsMenu, { "data-e2e": 'InfoBoxMobile_ControlsMenu' }), (0, jsx_runtime_1.jsxs)(Content, { "data-e2e": 'InfoBoxMobile_Content', children: [(0, jsx_runtime_1.jsx)(TopSection, { "data-e2e": 'InfoBoxMobile_TopSection', children: (0, jsx_runtime_1.jsx)(molecules_1.Title, { title: (names === null || names === void 0 ? void 0 : names.title) || '', altTitle: names === null || names === void 0 ? void 0 : names.latin, withAudio: Boolean(audio === null || audio === void 0 ? void 0 : audio.length), playing: isAudioPlaying, "data-e2e": 'InfoBoxMobile_Title' }) }), (0, jsx_runtime_1.jsx)(BottomSection, { "data-e2e": 'InfoBoxMobile_BottomSection', children: (0, jsx_runtime_1.jsx)(TabCarousel_1.default, { "data-e2e": 'InfoBoxMobile_TabCarousel' }) })] })] }) }) }));
}
exports.InfoBoxMobile = InfoBoxMobile;
const HIDDEN_CONTENT_TRANSLATE = 'calc(100% - 210px)';
const Container = styled_components_1.default.div `
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;

  height: auto;

  transition: transform 0.2s ease-in-out;

  &.infoBox-enter {
    transform: translateY(100%);
  }

  &.infoBox-enter-active {
    transform: translateY(0);
  }

  &.infoBox-enter-done {
    transform: none;
  }

  &.infoBox-exit {
    transform: translateY(0);
  }

  &.infoBox-exit-active {
    transform: translateY(100%);
  }

  &.content-enter {
    transform: translateY(${HIDDEN_CONTENT_TRANSLATE});
  }

  &.content-enter-active {
    transform: translateY(0);
  }

  &.content-enter-done {
    transform: none;
  }

  &.content-exit {
    transform: translateY(0);
  }

  &.content-exit-active {
    transform: translateY(${HIDDEN_CONTENT_TRANSLATE});
  }

  &.content-exit-done {
    transform: translateY(${HIDDEN_CONTENT_TRANSLATE});
  }

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    z-index: 1;
  `)}
`;
const Content = styled_components_1.default.div `
  display: flex;
  flex-flow: column nowrap;
  height: auto;

  @media (orientation: portrait) {
    max-height: calc(100vh - 75vw);
  }
  @media (orientation: landscape) {
    max-height: 100vh;
  }
`;
const TopSection = styled_components_1.default.div `
  flex-shrink: 0;

  background-color: ${props => props.theme.backgroundWithOpacity};
`;
const BottomSection = styled_components_1.default.div `
  display: flex;
  overflow: hidden;

  background-color: ${props => props.theme.backgroundWithOpacity};
`;
